/* eslint-disable react/react-in-jsx-scope */
import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
interface DialogInprogressProps {
  open: boolean;
  onClose?: () => void;
}
const DialogInprogress = (props: DialogInprogressProps) => {
  const { open, onClose } = props;

  return (
    <Dialog
      open={open}
      maxWidth={"md"}
      onClose={() => {
        onClose && onClose();
      }}
    >
      <DialogTitle>
        <Typography variant="h4">Transaction in progress</Typography>
      </DialogTitle>
      <DialogContent>
        <Stack
          spacing={2}
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
          <Typography variant="h6">Please wait</Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
export default DialogInprogress;
